var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{staticClass:"rounded button is-warning rounded-lg text-decoration-none mr-1",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleInput(_vm.target)}}},[_vm._v(" Affecter à une agence ")]),_c('AffectUserToAgencyModal',{ref:"modal",on:{"hide":function($event){return _vm.$emit('reload')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }